export default __webpack_public_path__ + "static/media/CNo.30-0.bf02ae37.jpg";